function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Translate } from "../../I18N";

import Modal from "../../Layout/Modal";
import { Icon } from "../../UI";
import { saveRelationType } from "../actions/relationTypeActions";





const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{
  relationshipTypeSave: saveRelationType
},
dispatch);


const mapStateToProps = (state) => ({
  relationshipTypes: state.relationTypes
});

const connector = connect(mapStateToProps, mapDispatchToProps);



const AddRelationshipTypeButton = ({ relationshipTypeSave, relationshipTypes }) => {var _errors$relationshipT, _errors$relationshipT2;
  const [open, setOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit'
  });

  const onSave = (data) => {
    const relationship = {
      name: data.relationshipType,
      properties: []
    };
    relationshipTypeSave(relationship);
    setOpen(false);
  };

  const isNotDuplicated = (value) =>
  !(relationshipTypes !== null && relationshipTypes !== void 0 && relationshipTypes.find((type) => (type === null || type === void 0 ? void 0 : type.get('name')) === value));

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-default", onClick: () => setOpen(true) }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Add relationship type" }, void 0, "Add relationship type"))), /*#__PURE__*/



    _jsx(Modal, { isOpen: open, type: "content", className: "new-relationshipType-modal" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h3", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Add relationship type" }, void 0, "Add relationship type"))), /*#__PURE__*/



    _jsx("form", {}, void 0, /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "relationshipTypeInput" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Relationship" }, void 0, "Relationship")), /*#__PURE__*/

    React.createElement("input", _extends({
      type: "text",
      id: "relationshipTypeInput" },
    register('relationshipType', {
      required: true,
      validate: {
        duplicated: (value) => isNotDuplicated(value)
      }
    }), {
      autoComplete: "off" })),


    ((_errors$relationshipT = errors.relationshipType) === null || _errors$relationshipT === void 0 ? void 0 : _errors$relationshipT.type) === 'required' && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "This field is required" }, void 0, "This field is required")),





    ((_errors$relationshipT2 = errors.relationshipType) === null || _errors$relationshipT2 === void 0 ? void 0 : _errors$relationshipT2.type) === 'duplicated' && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Duplicated name" }, void 0, "Duplicated name"))), /*#__PURE__*/




    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn", onClick: () => setOpen(false) }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Cancel" }, void 0, "Cancel")), /*#__PURE__*/

    _jsx("button", { type: "button", className: "btn btn-success", onClick: handleSubmit(onSave) }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Save" }, void 0, "Save")))))));






};

const container = connector(AddRelationshipTypeButton);
export { container as AddRelationshipTypeButton };